<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn color="error" outlined class="ml-5" small v-on="on" @click="askRestart=true">
          <v-icon color="error" small class="mr-2">mdi-alert</v-icon>
          <span>Restart</span>
        </v-btn>
      </template>
      <span>Restart Server</span>
    </v-tooltip>

    <v-dialog v-model="askRestart" width="600">
      <v-card class="dialogCard">
        <v-card-title>Ask to Restart the server?</v-card-title>
        <v-card-text>
          <b>Important!</b> To debug server issues, <b>before you restart</b> the server,
          record a <b>1-minute video</b> of the operation and post it to <b>pkr2-operators</b>
          channel, with the debug console open.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="restart(); askRestart=false">Confirm, I Made Video</v-btn>
          <v-btn text @click="askRestart=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import {mapGetters} from "vuex";

export default {
  name: "RestartServerAction",

  data() {
    return {
      askRestart: false,
    }
  },

  computed: {
    // ...mapGetters([
    //
    // ])
  },

  methods: {
    restart() {
      this.$axios.post("/api/restart", {}).then(() => {})
    }
  }
}
</script>

<style scoped>

</style>
